import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="text-2xl font-bold text-emerald-400" style={{ fontFamily: 'Pacifico, serif' }}>
                IRN
              </div>
              <div className="text-lg font-semibold">
                Integrated Recovery Network
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              Closing the revolving door between the justice system and homelessness through comprehensive, individualized support services since 2008.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/impact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Our Impact
                </Link>
              </li>
              <li>
                <Link to="/get-involved" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Get Involved
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <i className="ri-phone-line text-emerald-400"></i>
                <span className="text-gray-300">(213) 977-9447</span>
              </div>
              <div className="flex items-center space-x-2">
                <i className="ri-mail-line text-emerald-400"></i>
                <span className="text-gray-300">IRNReception@gmail.com</span>
              </div>
              <div className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-emerald-400 mt-1"></i>
                <span className="text-gray-300">
                  2010 Wilshire Blvd STE 704<br />
                  Los Angeles, CA 90011
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6 text-center">
          <p className="text-gray-400">
            &copy; 2024 Integrated Recovery Network. All rights reserved. | 501(c)(3) Non-Profit Organization
          </p>
        </div>
      </div>
    </footer>
  );
}
